// extracted by mini-css-extract-plugin
module.exports = {"list":"WebSideMenu_list__19jLz","logo":"WebSideMenu_logo__2eXnn","closeMenu":"WebSideMenu_closeMenu__2Mzxz","SideMenuHeader":"WebSideMenu_SideMenuHeader__2W_h9"};